import React from 'react';

import { Spin as AntdSpin } from 'antd';
import type { SpinProps } from 'antd';

type LegacySpinProps = SpinProps & {
  message?: React.ReactNode;
  width?: string | number;
};

const Spin = ({ message, tip, width: _width, ...props }: LegacySpinProps) => (
  <AntdSpin tip={tip ?? message} {...props} />
);

export default Spin;
